import React, { Component } from "react";
import { Animated } from "react-animated-css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Map from "./Map";
import Testimonials from "./Testimonials";

class Resources extends Component {
  render() {
    return (
      <div>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Navbar />
        </Animated>
        <div className="b b-- b--fw">
          <div className="b-c">
            <div className="sh ">
              <h2 className="sh-title">Locations Service Provided</h2>
            </div>
          </div>
        </div>
        <Map />
        <Testimonials />
        <Footer />
      </div>
    );
  }
}

export default Resources;
